/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDigitalBillAndMoveOrderLinesDto
 */
export interface CreateDigitalBillAndMoveOrderLinesDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDigitalBillAndMoveOrderLinesDto
     */
    primaryReference: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CreateDigitalBillAndMoveOrderLinesDto
     */
    orderLineQuantityMap: { [key: string]: number; };
}

/**
 * Check if a given object implements the CreateDigitalBillAndMoveOrderLinesDto interface.
 */
export function instanceOfCreateDigitalBillAndMoveOrderLinesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "primaryReference" in value;
    isInstance = isInstance && "orderLineQuantityMap" in value;

    return isInstance;
}

export function CreateDigitalBillAndMoveOrderLinesDtoFromJSON(json: any): CreateDigitalBillAndMoveOrderLinesDto {
    return CreateDigitalBillAndMoveOrderLinesDtoFromJSONTyped(json, false);
}

export function CreateDigitalBillAndMoveOrderLinesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDigitalBillAndMoveOrderLinesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'primaryReference': json['primaryReference'],
        'orderLineQuantityMap': json['orderLineQuantityMap'],
    };
}

export function CreateDigitalBillAndMoveOrderLinesDtoToJSON(value?: CreateDigitalBillAndMoveOrderLinesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'primaryReference': value.primaryReference,
        'orderLineQuantityMap': value.orderLineQuantityMap,
    };
}

